<template>
  <div ref="audio_video_player_box_ref" 
       :class="{'audio-video-player-box':true,'full-screen-style': fullStatus}">
    <dl>
      <dt class="player-box">
        <div class="player-type-xgPlayer">
          <xgPlayer ref="player_ref"
                    :id="id"
                    :url="playUrl"
                    :poster="coverUrl" 
                    :config="playConfig"
                    @statusChange="getVideoStatusChangeInfo"/>
        </div>
      </dt>
      <dd class="normal-view-box">
        <view-control :viewType="viewControlType" 
                      :bannedControl="bannedControl"
                      :isWaiting="isWaitingStatus"
                      :isPause="isPauseStatus"
                      :times="currentShowTime"
                      :duration="showDuration"
                      :isFull="fullStatus"
                      :showClose="showCloseStatus"
                      :progressPoint="progressPoints"
                      :showSwitchAudio="audioBarShowStatus"
                      :clearScreen="clearScreenStatus"
                      :poster="coverUrl" 
                      :tryWatchTime="canWatchTime"
                      @progressChange="getViewControlProgressInfo"
                      @clickInfo="getViewControlClickInfo"/>
      </dd>
    </dl>
  </div>
</template>

<script>
// 播放器 start
import xgPlayer from './player/xigua';
// 播放器 end

// 视图 start
import viewControl from './view/view_control';  // audioNormalView(音频)  videoNormalView(视频)
// 视图 end

// 函数方法 start
import { formatSeconds, dealShowTotaltime } from '@/utils/utils';

// 函数方法 end
export default {
  props: {
    id: [Number,String],
    bannedControl: {
      type: Boolean,
      default: false,
    },
    // 播放器 start
    playUrl: [String],
    playConfig: [Object],
    playPauseStatus: [Boolean],
    playCurrentTime: [Number],
    // 播放器 end
    // 视图 start
    viewType: [String],
    coverUrl: [String],
    isFullStatus: [Boolean],
    tryWatchTime: [Number, String],
    isShowAudioSwitchBtn: {
      type: [Boolean],
      default: true
    },
    // 视图 end
  },
  components: {
    xgPlayer,

    // 视图 start
    viewControl,
    // 视图 end
  },
  data(){
    return {
      // 播放器 start
      videoInfo: null,
      duration: 0,
      durationModel: null,
      // 播放器 end
      
      // 视图模块显示 start
      viewControlType: '',
      viewTypeMap: {
        audio: 'audioNormalView',
        video: 'videoNormalView',
      },
      // 视图模块显示 start

      // 状态记录 start
      clearScreenInitCount: 20,
      clearScreenCount: 20,
      // 状态记录 end

      // 视图 start
      isWaitingStatus: false,
      isPauseStatus: true,
      currentShowTime: '',
      showDuration: '',
      fullStatus: false,
      showCloseStatus: false,
      audioBarShowStatus: true,
      clearScreenStatus: false,  // 隐藏屏幕视图，方便观看
      progressPoints: 0,  // 0-1
      canWatchTime: '',
      // 视图 end
    }
  },
  watch: {
    viewType: function() {
      this.setViewControlTypeByType(this.viewType);
    },
    playPauseStatus: function() {
      this.setPlayerPauseStatusByProps();
    },
    isFullStatus: function() {
      this.setPlayerFullScreenStatus();
    },
    playCurrentTime: function() {
      this.setCurrentPlayTimeWithChange();
    },
    tryWatchTime: function(){
      this.setShowLimitCanWatchTime();
    },
    isShowAudioSwitchBtn: function() {
      this.setIsShowAudioSwitchBtnStatus();
    },
  },
  mounted() {
    // this.setViewShowStatus();
    this.setShowLimitCanWatchTime();
    this.setIsShowAudioSwitchBtnStatus();
  },
  methods: {
    // 设置是否隐藏音视频切换按钮
    setIsShowAudioSwitchBtnStatus(){
      this.audioBarShowStatus = this.isShowAudioSwitchBtn;
    },
    setViewShowStatus: function() {
      this.setViewControlTypeByType(this.viewType);
    },
    // 外部控制 start
    setPlayerPauseStatusByProps: function() {
      this.setVideoPlayerStatus({
        type: 'playPause',
        status: this.playPauseStatus,
      })
    },
    setPlayerFullScreenStatus: function() {
      this.setViewStatusWithFullScreenChange(this.isFullStatus);
    },
    setCurrentPlayTimeWithChange: function() {
      this.setVideoPlayerStatus({
        type: 'currentTime',
        seconds: this.playCurrentTime,
      })
    },
    // 外部控制 end
    // 播放器 start
    getVideoStatusChangeInfo: function(videoData) {
      this.sendVideoPlayInfo(videoData);
      this.setViewShowStatusByVideoInfo(videoData);
    },
    getPlaySeconsByPoint: function(point) {
      return Math.round(this.duration * point);
    },
    getPlayPoints: function(currentTime) {
      const point = this.duration ? parseFloat(currentTime / this.duration).toFixed(2) : 0;

      return point;
    },
    // 播放器 end
    // 视图模块显示 start
    setViewControlTypeByType: function(showType) {
      this.viewControlType = this.viewTypeMap[showType] || 'videoNormalView';
    },
    // 视图模块显示 end
    // 组件显示控制 start
    setViewShowStatusByVideoInfo: function(videoData) {
      const videoPlayData = videoData;
      const statusType = videoPlayData.statusType;
      const currentTime = videoPlayData.currentTime;

      this.auditionOverToSetVideoPause(currentTime);
      
      switch (statusType) {
        // case 'ready':
        case 'durationchange':
          const duration = videoPlayData.duration;
          this.setShowDuration(duration);
        break;
        case 'waiting':
          this.isWaitingStatus = true;
        break;
        case 'play':
        case 'bufferedChange':
          this.isPauseStatus = videoPlayData.isPause;
        break;
        case 'pause':
          this.isPauseStatus = videoPlayData.isPause;
          this.openScreenControl();
        break;
        case 'canplay':
          this.setShowCurrentTimes(currentTime);
        break;
        case 'timeupdate':
          this.isWaitingStatus = false;
          
          this.setShowCurrentTimes(currentTime);
          this.recordClearScreenCount();
        break;
        case 'ended':
          this.openScreenControl();
        break;
      }
    },
    // 设置当前播放时间
    setShowCurrentTimes: function(seconds) {
      const durationModel = this.durationModel;
      const timeModel = formatSeconds(seconds);
      let showTime = this.getShowSecond(timeModel);

      if (durationModel && durationModel.h && !timeModel.h) {
        showTime = '00:' + showTime;
      }
  
      this.currentShowTime = showTime;
      this.setCurrentPlayPoint(seconds);
    },
    // 设置当前总时间
    setShowDuration: function(seconds) {
      const durationModel = formatSeconds(seconds);

      this.duration = seconds;
      this.durationModel = durationModel;
      this.showDuration = this.getShowSecond(durationModel);
    },
    getShowSecond: function(secondsModel) {
      const h = secondsModel.h ? secondsModel.h + ':' : '';
      const m = secondsModel.m ? secondsModel.m + ':' : '00:';
      const s = secondsModel.s ? secondsModel.s : '';
      let showTime = '';
  
      showTime = h + m + s;
  
      return showTime;
    },
    setCurrentPlayPoint: function(currentTime) {
      const setPoints = this.getPlayPoints(currentTime);
      this.progressPoints = parseFloat(setPoints);
    },
    // 组件显示控制 end
    // ---------数据控制 start


    // ---------数据控制 end
    // ---------视图控制 start
    setVideoPlayerStatus: function(setData) {
      const playerRef = this.$refs.player_ref;
  
      if (!playerRef) {
        return;
      }

      const setType = setData.type;

      switch (setType) {
        case 'currentTime':
          const seconds = setData.seconds;
          playerRef.setCurrentTime(seconds);
        break;
        case 'playPause':
          const status = setData.hasOwnProperty('status') ? setData.status : !this.isPauseStatus;

          this.isPauseStatus = status;
          playerRef.setPauseStatus(status);
        break;
        case 'multiple':
          const multipleNum = setData.num || 1;
          
          playerRef.setMultiple(multipleNum);
        break;
        case 'switchScreen':
          const switchStatus = setData.status;
          playerRef.setFullScreenStatus(switchStatus);
        break;
      }
    },
    recordClearScreenCount: function() {
      const downCount = this.clearScreenCount - 1;
      
      this.clearScreenCount = downCount;
      this.clearScreenStatus = downCount <= 0;
    },
    openScreenControl: function() {
      this.clearScreenStatus = false;
      this.clearScreenCount = this.clearScreenInitCount;
    },
    // ---------视图控制 end
    // 视图 start
    getViewControlProgressInfo: function(progressInfo) {
      this.controlPlayStatusByClick(progressInfo);
    },
    getViewControlClickInfo: function(clickInfo) {
      this.controlPlayStatusByClick(clickInfo);
    },
    // 控制内容播放器 
    controlPlayStatusByClick: function(constrolInfo) {
      this.sendClickControlInfo(constrolInfo);
      this.controlInternalVideoByClick(constrolInfo);
    },
    controlInternalVideoByClick: function(constrolInfo) {
      const buttonType = constrolInfo.buttonType;

      this.openScreenControl(); // 打开视图控制栏
    
      switch (buttonType) {
        case 'centerControl':

        break;
        case 'switchAudio':
          this.setViewControlTypeByType('audio');
        break;
        case 'switchVideo':
          this.setViewControlTypeByType('video');
        break;
        case 'playPause':
          this.setVideoPlayerStatus({
            type: 'playPause',
          })
        break;
        case 'selectedMultiple':
          const multipleNum = constrolInfo.multiple;

          this.setVideoPlayerStatus({
            type: 'multiple',
            num: multipleNum,
          })
        break;
        case 'fullScreen':
          this.setViewStatusWithFullScreenChange();
        break;
        case 'progressBar':
          const poins = constrolInfo.point;
          const seconds = this.getPlaySeconsByPoint(poins);
      
          this.setVideoPlayerStatus({
            type: 'currentTime',
            seconds: seconds,
          })
        break;
        case 'goBack':
          this.setViewStatusWithFullScreenChange();
        break;
      }
    },
    setViewStatusWithFullScreenChange: function(isFull) {
      this.setFullStatus(isFull);

      this.showCloseStatus = this.fullStatus;
      if (this.isShowAudioSwitchBtn) {
        this.audioBarShowStatus = !this.fullStatus;
      }
      this.setFullScreenShowStyle(this.fullStatus);

      // this.setVideoPlayerStatus({
      //   type: 'switchScreen',
      //   status: this.fullStatus,
      // })
    },
    setFullStatus: function(isFull) {
      this.fullStatus  = typeof(isFull) != 'undefined' ? isFull : !this.fullStatus;
    },
    setFullScreenShowStyle: function(isFull) {
      const videoBoxEl = this.$refs.audio_video_player_box_ref;
      const winW = document.documentElement.clientWidth || document.body.clientWidth;
      const winH = document.documentElement.clientHeight || document.body.clientHeight;

      let showW = winW > winH ? winW : winH;
      let showH = winW > winH ? winH : winW;

      videoBoxEl.style.transition = 'all 0.3s ease-out'; 

      if (isFull) {
        // videoBoxEl.style.position = 'fixed';
        videoBoxEl.style.setProperty('position', 'fixed', 'important');
        videoBoxEl.style.transformOrigin = 'left top';
        videoBoxEl.style.top = '0px';
        videoBoxEl.style.left =  showH + 'px';
        videoBoxEl.style.width = showW + 'px';
        // videoBoxEl.style.height = showH + 'px';
        videoBoxEl.style.setProperty('height', showH + 'px', 'important');
        videoBoxEl.style.zIndex = '999';
        videoBoxEl.style.transform = 'rotateZ(90deg)';
      } else {
        videoBoxEl.style.position = 'relative';
        videoBoxEl.style.left = '0';
        videoBoxEl.style.width = '100%';
        videoBoxEl.style.height = '100%';
        videoBoxEl.style.zIndex = '1';
        videoBoxEl.style.transform = 'rotateZ(0)';
      }
    },
    // 视图 end
    sendVideoPlayInfo: function(playInfo) {
      const playData = {
        id: this.id,
        data: playInfo,
      };

      this.$emit('videoInfo',playData);
    },
    sendClickControlInfo: function(clickInfo) {
      const clickData = {
        id: this.id,
        data: clickInfo,
      };

      this.$emit('clickInfo',clickData);
    },

    // 试看 start
    // 设置显示的试看时间处理
    setShowLimitCanWatchTime(){
      this.canWatchTime = dealShowTotaltime(this.tryWatchTime, 0);
      console.log(' --- this.canWatchTime = ' + this.canWatchTime);
    },
    // 试看结束 关闭视频播放
    auditionOverToSetVideoPause(currentPlayTime){
      // console.log('currentPlayTime = ' + currentPlayTime);
      if (this.tryWatchTime && currentPlayTime >= this.tryWatchTime) {
        this.setVideoPlayerStatus({
          type: 'currentTime',
          seconds: 0
        });
        this.setVideoPlayerStatus({
          type: 'playPause',
          status: true
        });
        let sendInfo = {
          statusType: 'tryWatchOver',
        };
        this.sendVideoPlayInfo(sendInfo);
      }
    },
    // 试看 end
  },
};
</script>

<style lang="less">
  .audio-video-player-box {
    position: relative;
    height: 100%;
    &>dl {
      position: relative;
      height: 100%;
      transition: all 0.5s ease;
      &>dt {
        height: 100%;
        &>.player-type-audioStreamer {
          overflow: hidden;
          height: 0;
          opacity: 0;
        }
        &>.player-type-xgPlayer {
          position: relative;
          z-index: 2;
          height: 100%;
        }
      }
      &>.normal-view-box {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        width: 100%;
        height: 100%;
      }
    }
  }
  div.full-screen-style {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/video_player/audio_video_player.vue